import { 
  PageKnowledgeHubLayout, PageKnowledgeHubLayoutProps, SliceColorStrip, 
  SliceColorStripProps, SliceContactForm, SliceContactFormProps, SliceContentEntityQuote, 
  SliceHeaderDivider, SliceHeaderDividerProps, SliceInlineBanner, SliceIntro, createSliceLayout, SlicePersonBioGrid, SlicePersonBioGridProps,
  SliceModalButton,
  SliceModalButtonProps
 } from '@shapeable/ui';
import { BRAND_COLORS } from '../../theme';
import { ContactUsIframeEmbed } from '../elements/contact-us-iframe-embed';

export const SliceLayoutIntroBackground = createSliceLayout(
  SliceInlineBanner, {
    boundary: 'content',
    aspectRatio: {
      base: 21 / 9,
    }
  }
);

export const SliceLayoutKnowledgeHub = createSliceLayout<PageKnowledgeHubLayoutProps>(
  PageKnowledgeHubLayout, {
    boundary: 'content-bleed',
    verticalPadding: 'medium',
    props: {
      filterSize: 'slim',
      filterSpacing: 3,
      showAllTab: true,
      entityTypes: { 
        Post: { filterFieldNames: [ "type", "topics", "challenges", "authors"] }, 
        Video: { filterFieldNames: [ "topics", "challenges", "people" ] } 
      }
    }
  }
);

export const SliceLayoutKeyMessage = createSliceLayout(
  SliceContentEntityQuote, {
    boundary: 'none',
  }
)

export const SliceLayoutContactForm = createSliceLayout<SliceContactFormProps>(
  SliceContactForm, {
    props: {
      variant: 'reveal',
    }
  }
);

export const SliceLayoutHeader = createSliceLayout<SliceHeaderDividerProps>(
  SliceHeaderDivider, {
    boundary: 'content-bleed',
    props: {
    }
  }
);

export const SliceLayoutColorStrip = createSliceLayout<SliceColorStripProps>(
  SliceColorStrip, {
    boundary: 'none',
    props: {
      colors: BRAND_COLORS
    }
  }
);

export const SliceLayoutIntro = createSliceLayout(
  SliceIntro, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutPeople = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    props: {
      showOrganisation: true,
    }
  }
);

export const SliceLayoutModalButton = createSliceLayout<SliceModalButtonProps>(
  SliceModalButton, {
    boundary: 'none',
    verticalPadding: 'content',
    props: {
      modalLayout: ContactUsIframeEmbed,
      label: "Show contact us form",
    }
  }
);
